import { router } from '@inertiajs/vue2';

export default {
  inject: [
    'mainLayout',
    'settingsLayout',
  ],

  data() {
    return {
      removeNavigateEventListener: router.on('before', (event) => {
        const httpMethod = event.detail.visit.method;
        if (
          httpMethod === 'get' &&
          this.form.isDirty &&
          !confirm(
            this.$t('You have unsaved changes, are you sure you want to leave without saving?')
          )
        ) {
          event.preventDefault();
          window.eventBus.$emit('faq.main-layout:set-tab', this.mainLayout.activeTab);
          window.eventBus.$emit('faq.settings-layout:set-tab', this.settingsLayout.activeTab);
        }
      })
    }
  },

  beforeDestroy() {
    this.removeNavigateEventListener();
  },
}